// extracted by mini-css-extract-plugin
module.exports = {"bongoLogo":"BongoLogo_bongoLogo__3hJYk"};